var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-page',{attrs:{"name":"login","wide":"","bg-image":"","centered":"","box":""}},[_c('login-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }